/**
 * @generated SignedSource<<d19f8fc63616caf32b27cfaf877db1b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionFollowupQuery$variables = {
  after?: string | null;
  endAt?: string | null;
  first?: number | null;
  id: string;
  startAt?: string | null;
};
export type RoutineOccasionFollowupQuery$data = {
  readonly routine: {
    readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionFollowupOccasionList_routine" | "RoutineOccasionFollowupSections_routine">;
  } | null;
};
export type RoutineOccasionFollowupQuery = {
  response: RoutineOccasionFollowupQuery$data;
  variables: RoutineOccasionFollowupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endAt"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startAt"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineOccasionFollowupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineOccasionFollowupOccasionList_routine"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineOccasionFollowupSections_routine"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoutineOccasionFollowupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "endAt",
                "variableName": "endAt"
              },
              {
                "kind": "Variable",
                "name": "startAt",
                "variableName": "startAt"
              }
            ],
            "concreteType": "RoutineSection",
            "kind": "LinkedField",
            "name": "activeSections",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeam",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "lastVersion",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unit",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskNumber",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sentiments",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskCheck",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "RoutineOccasionConnection",
            "kind": "LinkedField",
            "name": "occasions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasionSection",
                        "kind": "LinkedField",
                        "name": "occasionSections",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "taskExecutions",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isTaskExecution"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isOptional",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "checkValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TaskExecutionCheck",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formattedNumberValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TaskExecutionNumber",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TaskExecutionText",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "Routine_occasions",
            "kind": "LinkedHandle",
            "name": "occasions"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "42192e8ed6b2410026c26674fbba1f7f",
    "id": null,
    "metadata": {},
    "name": "RoutineOccasionFollowupQuery",
    "operationKind": "query",
    "text": "query RoutineOccasionFollowupQuery(\n  $id: ID!\n  $after: String\n  $first: Int\n  $endAt: String\n  $startAt: String\n) {\n  routine(id: $id) {\n    ...RoutineOccasionFollowupOccasionList_routine\n    ...RoutineOccasionFollowupSections_routine\n    id\n  }\n}\n\nfragment RoutineOccasionFollowupColumn_RoutineOccasion on RoutineOccasion {\n  id\n  startAt\n  endAt\n  status\n  occasionSections {\n    id\n    section {\n      id\n    }\n    taskExecutions {\n      __typename\n      id\n      task {\n        __typename\n        id\n      }\n      ...RoutineOccasionFollowupResultCell_taskExecution\n    }\n  }\n}\n\nfragment RoutineOccasionFollowupColumn_routine on Routine {\n  activeSections(endAt: $endAt, startAt: $startAt) {\n    id\n    assignedTeam {\n      id\n      name\n    }\n    lastVersion {\n      id\n      title\n      tasks {\n        __typename\n        id\n        title\n      }\n    }\n  }\n}\n\nfragment RoutineOccasionFollowupOccasionList_routine on Routine {\n  id\n  ...RoutineOccasionFollowupColumn_routine\n  occasions(first: $first, after: $after) {\n    edges {\n      node {\n        ...RoutineOccasionFollowupColumn_RoutineOccasion\n        id\n        startAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RoutineOccasionFollowupResultCell_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  __typename\n  isOptional\n  ... on TaskExecutionCheck {\n    checkValue\n  }\n  ... on TaskExecutionNumber {\n    formattedNumberValue\n  }\n  ... on TaskExecutionText {\n    textValue\n  }\n}\n\nfragment RoutineOccasionFollowupSections_routine on Routine {\n  activeSections(endAt: $endAt, startAt: $startAt) {\n    id\n    assignedTeam {\n      id\n      name\n    }\n    lastVersion {\n      id\n      title\n      tasks {\n        __typename\n        ... on TaskNumber {\n          unit\n        }\n        ... on TaskCheck {\n          sentiments\n        }\n        id\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "96a4e371a1268fb7c3efebb6128c8fcc";

export default node;
